<template>
  <div class="relative">
    <i
      class="iconfont icon-close cursor-pointer absolute text-center"
      aria-hidden="true"
      @click.stop="closeVideo"
    />
    <video-player
      ref="videoPlayer"
      class="video-player vjs-custom-skin"
      :playsinline="true"
      :options="playerOptions"
    />

    <div @click.stop="closeVideo">
      <Masker :data="show"></Masker>
    </div>
  </div>
</template>

<script>
import Masker from '@/components/common/Mask'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import { videoPlayer } from 'vue-video-player'
window.videojs = require('video.js')
require('video.js/dist/lang/zh-CN')
export default {
  name: 'VideoPlayerComponent',
  components: {
    videoPlayer,
    Masker
  },
  mixins: [],
  props: {
    data: Object,
    type: String,
    autoplay: Boolean,
    show: Boolean
  },
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: this.autoplay || false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4',
            src: '' //url地址
          }
        ],
        poster: '', //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }
    }
  },
  watch: {
    data() {
      this.loading(this.data)
    },
    autoplay() {
      this.playerOptions.autoplay = this.autoplay
    }
  },
  mounted: function() {
    this.loading(this.data)
  },
  methods: {
    closeVideo() {
      this.$parent.showModal = null
    },
    loading(data) {
      if (data && this.type === 'video') {
        this.playerOptions.sources[0].src = data.video_url
        this.playerOptions.poster = data.thumbnail_url
      } else {
        this.playerOptions.sources[0].src = data.attachment_url
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.s-modal-mask {
  z-index: -1;
}
.video-js {
  height: 100%;
}
.video-js .vjs-big-play-button {
  cursor: pointer;
  // opacity: 0;
  width: 5rem;
  height: 5rem !important;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -2.5rem;
  margin-top: -2.5rem;
  // background-image: url('../../../static/images/public/play-big.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: rgba(0, 0, 0, 0);
  border: 0 none;
  .vjs-icon-placeholder {
    &::before,
    &::after {
      content: '';
    }
  }

  &:hover,
  &.active {
    transition: all 0.35s;
    -moz-transition: all 0.35s; /* Firefox 4 */
    -webkit-transition: all 0.35s; /* Safari 和 Chrome */
    -o-transition: all 0.35s; /* Opera */
    opacity: 1;
  }
}
.icon-close {
  top: 0;
  right: -2.75rem;
  width: 2.75rem;
  height: 2.75rem;
  line-height: 2.75rem;
  // border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.7);
  font-size: 1.8rem;
  color: #fff;
  &:hover {
    opacity: 0.6;
  }
}
</style>
